import Swiper from 'swiper/bundle'

const AUTOPLAY_DELAY = 15000


export default class SliderImg {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.swiperText = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.slider-img--slider')
    const swiperTextEl = this.el.querySelector('.slider-img--text-slider')
    const arrowEl = this.el.querySelector('.slider-img--arrow')
    if (!swiperEl) return

    // Flèche droite = contenu glisse vers la droite = direction inversée
    const isReversed = arrowEl?.classList.contains('prev')
    const isFull = this.el.classList.contains('slider-img--full')

    // En mode card, détecter si certains slides n'ont pas d'image
    const slideEls = Array.from(swiperEl.querySelectorAll('.swiper-slide'))
    const hasImgMap = slideEls.map(s => s.dataset.hasImg !== '0')
    const isMixed = !isFull && hasImgMap.some(v => !v) && hasImgMap.some(v => v)

    // Un dot uniquement pour les slides qui ont réellement du texte
    const hasTextMap = swiperTextEl
      ? Array.from(swiperTextEl.querySelectorAll('.swiper-slide')).map(s => s.dataset.hasText === '1')
      : []

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const autoplay = (isMixed || reduceMotion) ? false : {
      delay: AUTOPLAY_DELAY,
      disableOnInteraction: false,
      reverseDirection: isReversed,
    }

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      grabCursor: true,
      speed: 1000,
      threshold: 5,
      longSwipesRatio: 0.15,
      longSwipesMs: 200,
      autoplay,
      breakpoints: {
        0: { speed: 500 },
        992: { speed: 1000 },
      },
    })

    if (swiperTextEl) {
      this.swiperText = new Swiper(swiperTextEl, {
        slidesPerView: 1,
        loop: !isFull,
        speed: 500,
        threshold: 5,
        longSwipesRatio: 0.15,
        longSwipesMs: 200,
        effect: 'slide',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: (index, className) => hasTextMap[index]
            ? `<span class="${className}" data-swiper-slide-index="${index}"></span>`
            : '',
        },
        ...(isMixed && !reduceMotion ? {
          autoplay: { delay: AUTOPLAY_DELAY, disableOnInteraction: false, reverseDirection: isReversed },
        } : {}),
      })

      if (isFull) {
        this.swiper.on('slideChange', () => {
          const activeSlide = this.swiper.slides[this.swiper.activeIndex]
          if (activeSlide?.dataset.hasText === '1') {
            this.swiperText.slideTo(this.swiper.realIndex)
          }
        })
        this.swiperText.on('slideChange', () => {
          if (this.swiper.realIndex !== this.swiperText.realIndex) {
            this.swiper.slideToLoop(this.swiperText.realIndex)
          }
        })
      } else if (isMixed) {
        // Le slider texte pilote ; l'image suit uniquement si le slide destination a une image
        this.swiperText.on('slideChange', () => {
          const idx = this.swiperText.realIndex
          if (hasImgMap[idx]) {
            this.swiper.slideToLoop(idx)
          }
        })
        this.swiper.on('slideChange', () => {
          if (this.swiperText.realIndex !== this.swiper.realIndex) {
            this.swiperText.slideToLoop(this.swiper.realIndex)
          }
        })
      } else {
        this.swiper.controller.control = this.swiperText
        this.swiperText.controller.control = this.swiper
      }
    }

    const master = isMixed && swiperTextEl ? this.swiperText : this.swiper

    arrowEl?.addEventListener('click', () => {
      isReversed ? master.slidePrev() : master.slideNext()
    })
    this.el.querySelector('.slider-img--nav-btn.prev')?.addEventListener('click', () => master.slidePrev())
    this.el.querySelector('.slider-img--nav-btn.next')?.addEventListener('click', () => master.slideNext())

    this.initAutoplayControls(master, !!master.params.autoplay)
  }

  // Pause manuelle (bouton), survol et toucher arrêtent le défilement automatique
  initAutoplayControls(master, hasAutoplay) {
    const pauseBtn = this.el.querySelector('.slider-img--pause')
    if (!hasAutoplay) {
      pauseBtn?.remove()
      return
    }

    let userPaused = false

    const setPaused = (paused) => {
      userPaused = paused
      pauseBtn?.classList.toggle('is-paused', paused)
      pauseBtn?.setAttribute('aria-pressed', String(paused))
      pauseBtn?.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre en pause le défilement')
      paused ? master.autoplay.stop() : master.autoplay.start()
    }

    pauseBtn?.addEventListener('click', () => setPaused(!userPaused))

    this.el.addEventListener('mouseenter', () => master.autoplay.stop())
    this.el.addEventListener('mouseleave', () => {
      if (!userPaused) master.autoplay.start()
    })

    // Un toucher arrête définitivement le défilement ; le bouton permet de le relancer
    this.el.addEventListener('touchstart', () => {
      if (!userPaused) setPaused(true)
    }, { passive: true })
  }
}
